module.exports = __webpack_public_path__ + "media/customizations/harvestgreen/logo-646a6f9ee50c5c9ccdcd5f6de823d74c.png";